// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Row, Col, Button, Form, FormGroup, Alert } from 'react-bootstrap';
import { Field, reduxForm, getFormValues } from 'redux-form';
import Input from '../../components/Input';
import {
  validateRequired,
  validateMobilePhoneNumber,
  validateEmail
} from '../../helpers';
import type { MapStateToProps } from 'react-redux';

type State = {
  passwordOpen: boolean
};

type Props = {
  isSaving: boolean,
  handleSubmit: (u: Object) => void,
  enableReinitialize: boolean,
  messageType: any,
  message: any,
  recheckVerification: () => void,
  isVerified: boolean,
  hasCustomer: boolean,
  navigateToCreateCustomer: () => void,
  navigateToDashboard: () => void,
  isVerifying: boolean
};

class MyAccountForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      passwordOpen: false
    };
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <FormGroup>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="text"
                label="Name"
                name="name"
                validate={validateRequired}
              />
            </Col>
          </FormGroup>
        </Row>
        <Row>
          <FormGroup>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="email"
                name="email"
                label="Email"
                validate={[validateRequired, validateEmail]}
              />
            </Col>
          </FormGroup>
        </Row>
        <Row>
          <FormGroup>
            <Col sm={12} className="form-input">
              <Field
                component={Input}
                type="phone"
                name="phone"
                label="Mobile Phone"
                validate={[validateRequired, validateMobilePhoneNumber]}
              />
            </Col>
          </FormGroup>
        </Row>

        <Field component={Input} type="hidden" name="dateUpdated" />

        {this.props.isVerified && (
          <Row>
            <Col sm={12} className="text-right">
              <Link to="/account/update-password">Update Password</Link>
            </Col>
          </Row>
        )}

        <Row style={{ marginTop: '20px' }}>
          <Col sm={6}>
            {this.props.isVerified && (
              <Button
                bsStyle="primary"
                type="submit"
                className="relative-padding"
                disabled={this.props.isSaving}
              >
                {this.props.isSaving ? 'Saving...' : 'Save'}
              </Button>
            )}
          </Col>
          <Col sm={6}>
            {!this.props.isVerified && (
              <Button
                bsStyle="primary"
                type="button"
                className="relative-padding pull-right"
                disabled={this.props.isVerifying}
                onClick={this.props.recheckVerification}
              >
                {this.props.isVerifying ? 'Verifying...' : 'Next'}
              </Button>
            )}
            {this.props.isVerified && !this.props.hasCustomer && (
              <Button
                bsStyle="primary"
                type="button"
                className="relative-padding pull-right"
                onClick={this.props.navigateToCreateCustomer}
              >
                Create Customer
              </Button>
            )}
            {this.props.isVerified && this.props.hasCustomer && (
              <Button
                bsStyle="primary"
                type="button"
                className="relative-padding pull-right"
                onClick={this.props.navigateToDashboard}
              >
                Go To Dashboard
              </Button>
            )}
          </Col>
        </Row>
        <br />
        {this.props.message && (
          <Alert bsStyle={this.props.messageType}>{this.props.message}</Alert>
        )}
      </Form>
    );
  }
}

// Decorate the form component
MyAccountForm = reduxForm({
  form: 'myAccountForm'
})(MyAccountForm);

const mapStateToProps: MapStateToProps<*, *, *> = state => {
  return {
    formValues: getFormValues('myAccountForm')(state)
  };
};

export default connect(mapStateToProps)(MyAccountForm);



// WEBPACK FOOTER //
// ./src/containers/account/MyAccountForm.js